const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoostFireIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.48925 10.834C9.99042 8.34806 10.4901 4.68019 10.4901 2.62891C13.851 5.09045 15.7276 10.4067 15.9277 12.6289C17.3681 12.6289 18.2923 10.834 18.8925 9.80839C21.8934 20.0648 15.8034 22.1161 12.2024 22.6289C5.60046 21.6033 2.88864 15.4067 7.48925 10.834Z",
    fill: "#D24940",
    style: {
      fill: "#D24940",
      fill: "color(display-p3 0.8235 0.2863 0.2510)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2641 2.18297C10.4321 2.09778 10.6337 2.11423 10.7856 2.22553C12.5596 3.52476 13.9135 5.55139 14.8455 7.50319C15.6487 9.1851 16.162 10.8609 16.3568 12.0513C16.6961 11.9281 17.0221 11.6619 17.343 11.2811C17.7283 10.8238 18.0427 10.2792 18.3215 9.79648C18.369 9.71424 18.4155 9.63379 18.4611 9.55587C18.5619 9.38358 18.7555 9.28776 18.9537 9.31214C19.1518 9.33651 19.3164 9.4764 19.3725 9.66799C20.9002 14.8892 20.1504 18.1644 18.4025 20.1984C16.6824 22.2 14.1045 22.8631 12.273 23.1239C12.2241 23.1309 12.1745 23.1306 12.1257 23.123C8.68716 22.5888 6.19006 20.6931 5.1828 18.2523C4.16818 15.7938 4.71092 12.8906 7.1369 10.4794C9.4958 8.13484 9.99021 4.63456 9.99021 2.62891C9.99021 2.44055 10.0961 2.26817 10.2641 2.18297ZM16.4233 12.5562C16.3615 12.5745 16.2987 12.5897 16.2348 12.6013C16.1352 12.6194 16.0329 12.6289 15.9279 12.6289C15.7378 10.5181 14.0351 5.61577 10.9845 3.01995C10.8235 2.88293 10.6587 2.75233 10.4902 2.62891C10.4902 2.82174 10.4858 3.02885 10.4757 3.24793C10.3786 5.35934 9.75542 8.58176 7.48937 10.834C2.88877 15.4067 5.60058 21.6033 12.2025 22.6289C15.7232 22.1275 21.6229 20.1556 19.0801 10.4829C19.022 10.2621 18.9596 10.0373 18.8926 9.8084C18.8496 9.88185 18.805 9.95926 18.7586 10.0397C18.6906 10.1576 18.6188 10.2821 18.543 10.41C18.036 11.2666 17.3517 12.2797 16.4233 12.5562Z",
    fill: "#60050F",
    style: {
      fill: "#60050F",
      fill: "color(display-p3 0.3750 0.0177 0.0606)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48925 10.834C9.99042 8.34806 10.4901 4.68019 10.4901 2.62891C10.9835 2.99031 11.445 3.41325 11.8739 3.87891C12.1746 6.87891 10.0731 10.4789 8.32306 11.8789C7.07306 12.8789 5.94806 14.1289 5.94806 16.1289C5.94806 19.7349 9.57865 22.0288 11.6868 22.5368C11.8559 22.571 12.0278 22.6018 12.2024 22.6289C12.0445 22.6121 11.8715 22.5813 11.6868 22.5368C5.46215 21.2767 3.0103 15.2858 7.48925 10.834Z",
    fill: "#E95D54",
    style: {
      fill: "#E95D54",
      fill: "color(display-p3 0.9125 0.3666 0.3308)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21038 15.446C4.99383 18.8097 7.68911 21.9278 12.2026 22.629C15.8037 22.1162 21.8936 20.0649 18.8927 9.80851C18.8498 9.88196 18.8051 9.95937 18.7587 10.0398C18.7292 10.091 18.699 10.1434 18.668 10.1968C20.9507 19.2837 15.3287 21.1509 11.9611 21.629C7.93327 21.0052 5.40514 18.3942 5.21038 15.446ZM16.0403 12.6254C16.0032 12.6278 15.9658 12.629 15.928 12.629C15.7526 10.6809 14.2888 6.35513 11.6661 3.65918C14.0303 6.42693 15.2841 10.9365 15.4483 12.754C15.6474 12.754 15.8458 12.7079 16.0403 12.6254Z",
    fill: "#AB3028",
    style: {
      fill: "#AB3028",
      fill: "color(display-p3 0.6708 0.1882 0.1565)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1982 22.6289C5.32318 21.7539 8.82316 12.7539 12.4481 9.75391C11.8232 14.2539 15.2904 13.9822 15.6982 18.1289C15.9482 20.6706 14.9482 22.3789 12.1982 22.6289Z",
    fill: "#FF784E",
    style: {
      fill: "#FF784E",
      fill: "color(display-p3 1.0000 0.4712 0.3042)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1982 22.6289C6.97834 21.5734 9.22834 15.24 11.601 13.1289C11.6011 16.8234 14.4482 16.2956 14.4482 19.4622C14.4482 21.5734 13.4482 22.5039 12.1982 22.6289Z",
    fill: "#FFB45C",
    style: {
      fill: "#FFB45C",
      fill: "color(display-p3 1.0000 0.7068 0.3625)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.224 22.6289C15.0712 22.0734 13.4482 19.0039 12.0731 17.6289C12.1982 19.7539 11.0732 19.6289 10.9482 21.0039C10.8652 21.9168 11.6201 22.5363 12.224 22.6289Z",
    fill: "#F5992D",
    style: {
      fill: "#F5992D",
      fill: "color(display-p3 0.9625 0.6009 0.1765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1982 22.6289C13.6982 22.3789 12.9482 20.7539 12.1982 19.8789C12.0732 20.8789 11.5172 20.9789 11.4515 21.7352C11.4079 22.2373 11.8809 22.578 12.1982 22.6289Z",
    fill: "#E27F0A",
    style: {
      fill: "#E27F0A",
      fill: "color(display-p3 0.8875 0.4980 0.0407)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 22.5946C7.02477 21.4431 9.25282 15.2182 11.601 13.1289C11.601 13.9926 11.7566 14.6256 11.9951 15.1289C11.5211 15.5872 10.4982 17.0789 10.1982 19.3789C9.91812 21.5263 11.2501 22.388 12.0391 22.5946C12.0913 22.6066 12.1444 22.618 12.1982 22.6289C12.1484 22.6206 12.0951 22.6092 12.0391 22.5946Z",
    fill: "#FFC46A",
    style: {
      fill: "#FFC46A",
      fill: "color(display-p3 1.0000 0.7667 0.4167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7201 11.0517C18.8318 11.1329 18.8565 11.2893 18.7752 11.401C18.5991 11.6431 18.2816 12.0185 17.8912 12.3733C17.5038 12.7254 17.0254 13.075 16.5271 13.2411C16.3961 13.2848 16.2546 13.214 16.2109 13.083C16.1672 12.952 16.238 12.8104 16.369 12.7668C16.7707 12.6328 17.1882 12.3366 17.5549 12.0033C17.9187 11.6727 18.2137 11.323 18.3709 11.1069C18.4521 10.9952 18.6084 10.9705 18.7201 11.0517Z",
    fill: "#FF766D",
    style: {
      fill: "#FF766D",
      fill: "color(display-p3 1.0000 0.4644 0.4292)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7203 11.0517C18.8319 11.1329 18.8566 11.2893 18.7754 11.401C18.5955 11.6484 18.2678 12.0351 17.8654 12.3968C17.7627 12.4891 17.6046 12.4807 17.5123 12.378C17.42 12.2754 17.4284 12.1173 17.5311 12.025C17.9058 11.6882 18.2103 11.3279 18.3711 11.1069C18.4523 10.9952 18.6086 10.9705 18.7203 11.0517Z",
    fill: "#FFD2CF",
    style: {
      fill: "#FFD2CF",
      fill: "color(display-p3 1.0000 0.8241 0.8125)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9639 3.6294C11.1017 3.63801 11.2064 3.75671 11.1978 3.89451C11.0711 5.9208 10.4386 8.35017 9.27326 9.90391C9.19041 10.0144 9.03371 10.0368 8.92326 9.95391C8.8128 9.87107 8.79041 9.71437 8.87326 9.60391C9.95795 8.15766 10.5754 5.83703 10.6987 3.86332C10.7074 3.72552 10.826 3.62079 10.9639 3.6294Z",
    fill: "#FF766D",
    style: {
      fill: "#FF766D",
      fill: "color(display-p3 1.0000 0.4644 0.4292)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9638 3.6294C11.1016 3.63801 11.2063 3.75671 11.1977 3.89451C11.1518 4.62905 11.0398 5.4121 10.8618 6.18501C10.8309 6.31956 10.6967 6.40352 10.5621 6.37254C10.4276 6.34156 10.3436 6.20737 10.3746 6.07282C10.5465 5.32633 10.6545 4.57037 10.6987 3.86332C10.7073 3.72552 10.826 3.62079 10.9638 3.6294Z",
    fill: "#FFD2CF",
    style: {
      fill: "#FFD2CF",
      fill: "color(display-p3 1.0000 0.8241 0.8125)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3583 14.1869C11.4644 14.2752 11.4787 14.4329 11.3903 14.539C10.7945 15.2539 10.0677 16.7063 9.94739 18.1497C9.93593 18.2873 9.81509 18.3895 9.67749 18.378C9.5399 18.3666 9.43765 18.2457 9.44912 18.1082C9.57884 16.5515 10.352 15.0039 11.0062 14.2189C11.0946 14.1128 11.2522 14.0985 11.3583 14.1869Z",
    fill: "#FFDEC0",
    style: {
      fill: "#FFDEC0",
      fill: "color(display-p3 1.0000 0.8718 0.7542)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4482 15.1289C16.4482 15.267 16.3363 15.3789 16.1982 15.3789C16.0602 15.3789 15.9482 15.267 15.9482 15.1289C15.9482 14.9908 16.0602 14.8789 16.1982 14.8789C16.3363 14.8789 16.4482 14.9908 16.4482 15.1289Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6982 15.7539C15.6982 15.8229 15.6423 15.8789 15.5732 15.8789C15.5042 15.8789 15.4482 15.8229 15.4482 15.7539C15.4482 15.6849 15.5042 15.6289 15.5732 15.6289C15.6423 15.6289 15.6982 15.6849 15.6982 15.7539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9482 14.5039C16.9482 14.5729 16.8923 14.6289 16.8232 14.6289C16.7542 14.6289 16.6982 14.5729 16.6982 14.5039C16.6982 14.4349 16.7542 14.3789 16.8232 14.3789C16.8923 14.3789 16.9482 14.4349 16.9482 14.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1982 15.5039C17.1982 15.5729 17.1423 15.6289 17.0732 15.6289C17.0042 15.6289 16.9482 15.5729 16.9482 15.5039C16.9482 15.4349 17.0042 15.3789 17.0732 15.3789C17.1423 15.3789 17.1982 15.4349 17.1982 15.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4482 16.2539C16.4482 16.3229 16.3923 16.3789 16.3232 16.3789C16.2542 16.3789 16.1982 16.3229 16.1982 16.2539C16.1982 16.1849 16.2542 16.1289 16.3232 16.1289C16.3923 16.1289 16.4482 16.1849 16.4482 16.2539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1982 17.5039C16.1982 17.5729 16.1423 17.6289 16.0732 17.6289C16.0042 17.6289 15.9482 17.5729 15.9482 17.5039C15.9482 17.4349 16.0042 17.3789 16.0732 17.3789C16.1423 17.3789 16.1982 17.4349 16.1982 17.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9482 13.5039C14.9482 13.5729 14.8923 13.6289 14.8232 13.6289C14.7542 13.6289 14.6982 13.5729 14.6982 13.5039C14.6982 13.4349 14.7542 13.3789 14.8232 13.3789C14.8923 13.3789 14.9482 13.4349 14.9482 13.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6982 11.5039C14.6982 11.5729 14.6423 11.6289 14.5732 11.6289C14.5042 11.6289 14.4482 11.5729 14.4482 11.5039C14.4482 11.4349 14.5042 11.3789 14.5732 11.3789C14.6423 11.3789 14.6982 11.4349 14.6982 11.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6982 12.5039C14.6982 12.5729 14.6423 12.6289 14.5732 12.6289C14.5042 12.6289 14.4482 12.5729 14.4482 12.5039C14.4482 12.4349 14.5042 12.3789 14.5732 12.3789C14.6423 12.3789 14.6982 12.4349 14.6982 12.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 13.5039C14.1982 13.5729 14.1423 13.6289 14.0732 13.6289C14.0042 13.6289 13.9482 13.5729 13.9482 13.5039C13.9482 13.4349 14.0042 13.3789 14.0732 13.3789C14.1423 13.3789 14.1982 13.4349 14.1982 13.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44824 15.0039C8.44824 15.0729 8.39228 15.1289 8.32324 15.1289C8.25421 15.1289 8.19824 15.0729 8.19824 15.0039C8.19824 14.9349 8.25421 14.8789 8.32324 14.8789C8.39228 14.8789 8.44824 14.9349 8.44824 15.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94824 13.7539C7.94824 13.8229 7.89228 13.8789 7.82324 13.8789C7.75421 13.8789 7.69824 13.8229 7.69824 13.7539C7.69824 13.6849 7.75421 13.6289 7.82324 13.6289C7.89228 13.6289 7.94824 13.6849 7.94824 13.7539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44824 13.0039C9.44824 13.0729 9.39228 13.1289 9.32324 13.1289C9.25421 13.1289 9.19824 13.0729 9.19824 13.0039C9.19824 12.9349 9.25421 12.8789 9.32324 12.8789C9.39228 12.8789 9.44824 12.9349 9.44824 13.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44824 13.0039C8.44824 13.0729 8.39228 13.1289 8.32324 13.1289C8.25421 13.1289 8.19824 13.0729 8.19824 13.0039C8.19824 12.9349 8.25421 12.8789 8.32324 12.8789C8.39228 12.8789 8.44824 12.9349 8.44824 13.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69824 12.0039C9.69824 12.0729 9.64228 12.1289 9.57324 12.1289C9.50421 12.1289 9.44824 12.0729 9.44824 12.0039C9.44824 11.9349 9.50421 11.8789 9.57324 11.8789C9.64228 11.8789 9.69824 11.9349 9.69824 12.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19824 15.7539C8.19824 15.8229 8.14228 15.8789 8.07324 15.8789C8.00421 15.8789 7.94824 15.8229 7.94824 15.7539C7.94824 15.6849 8.00421 15.6289 8.07324 15.6289C8.14228 15.6289 8.19824 15.6849 8.19824 15.7539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44824 15.5039C7.44824 15.5729 7.39228 15.6289 7.32324 15.6289C7.25421 15.6289 7.19824 15.5729 7.19824 15.5039C7.19824 15.4349 7.25421 15.3789 7.32324 15.3789C7.39228 15.3789 7.44824 15.4349 7.44824 15.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94824 16.5039C6.94824 16.5729 6.89228 16.6289 6.82324 16.6289C6.75421 16.6289 6.69824 16.5729 6.69824 16.5039C6.69824 16.4349 6.75421 16.3789 6.82324 16.3789C6.89228 16.3789 6.94824 16.4349 6.94824 16.5039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69824 17.0039C7.69824 17.0729 7.64228 17.1289 7.57324 17.1289C7.50421 17.1289 7.44824 17.0729 7.44824 17.0039C7.44824 16.9349 7.50421 16.8789 7.57324 16.8789C7.64228 16.8789 7.69824 16.9349 7.69824 17.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69824 18.0039C7.69824 18.0729 7.64228 18.1289 7.57324 18.1289C7.50421 18.1289 7.44824 18.0729 7.44824 18.0039C7.44824 17.9349 7.50421 17.8789 7.57324 17.8789C7.64228 17.8789 7.69824 17.9349 7.69824 18.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1982 11.2539C13.1982 11.3229 13.1423 11.3789 13.0732 11.3789C13.0042 11.3789 12.9482 11.3229 12.9482 11.2539C12.9482 11.1849 13.0042 11.1289 13.0732 11.1289C13.1423 11.1289 13.1982 11.1849 13.1982 11.2539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9482 11.7539C13.9482 11.8229 13.8923 11.8789 13.8232 11.8789C13.7542 11.8789 13.6982 11.8229 13.6982 11.7539C13.6982 11.6849 13.7542 11.6289 13.8232 11.6289C13.8923 11.6289 13.9482 11.6849 13.9482 11.7539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4482 10.2539C13.4482 10.3229 13.3923 10.3789 13.3232 10.3789C13.2542 10.3789 13.1982 10.3229 13.1982 10.2539C13.1982 10.1849 13.2542 10.1289 13.3232 10.1289C13.3923 10.1289 13.4482 10.1849 13.4482 10.2539Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1982 14.6289C15.1982 14.767 15.0863 14.8789 14.9482 14.8789C14.8102 14.8789 14.6982 14.767 14.6982 14.6289C14.6982 14.4908 14.8102 14.3789 14.9482 14.3789C15.0863 14.3789 15.1982 14.4908 15.1982 14.6289Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44824 14.6289C7.44824 14.767 7.33631 14.8789 7.19824 14.8789C7.06017 14.8789 6.94824 14.767 6.94824 14.6289C6.94824 14.4908 7.06017 14.3789 7.19824 14.3789C7.33631 14.3789 7.44824 14.4908 7.44824 14.6289Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9482 12.6289C13.9482 12.767 13.8363 12.8789 13.6982 12.8789C13.5602 12.8789 13.4482 12.767 13.4482 12.6289C13.4482 12.4908 13.5602 12.3789 13.6982 12.3789C13.8363 12.3789 13.9482 12.4908 13.9482 12.6289Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94824 13.8789C8.94824 14.017 8.83631 14.1289 8.69824 14.1289C8.56017 14.1289 8.44824 14.017 8.44824 13.8789C8.44824 13.7408 8.56017 13.6289 8.69824 13.6289C8.83631 13.6289 8.94824 13.7408 8.94824 13.8789Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94824 16.3789C7.94824 16.517 7.83631 16.6289 7.69824 16.6289C7.56017 16.6289 7.44824 16.517 7.44824 16.3789C7.44824 16.2408 7.56017 16.1289 7.69824 16.1289C7.83631 16.1289 7.94824 16.2408 7.94824 16.3789Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1982 14.0039C16.1982 14.211 16.0303 14.3789 15.8232 14.3789C15.6161 14.3789 15.4482 14.211 15.4482 14.0039C15.4482 13.7968 15.6161 13.6289 15.8232 13.6289C16.0303 13.6289 16.1982 13.7968 16.1982 14.0039Z",
    fill: "#F44F44",
    style: {
      fill: "#F44F44",
      fill: "color(display-p3 0.9583 0.3101 0.2675)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostFireIcon);
export default __webpack_public_path__ + "static/media/boost-fire-icon.fd9759d051092622252648a1adcf1c9dca504744d9b7956b552e9bdbe65290d4.svg";
export { ForwardRef as ReactComponent };